module.exports = __webpack_public_path__ + "static/media/desert-large-off.8ca11f7b.png";